export default __webpack_public_path__ + "static/media/abstract2.b73221ff.jpg";